import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import SpendingSettingsSdkContainer from 'react/member/card/components/spending_monitor_tab/SpendingSettingsSdkContainer';
import TrueLinkBanner from 'react/shared/components/true_link/lab/TrueLinkBanner';

export default function SpendingSettingsSdkContainerWrapper({ accountId, cardSettings }) {
  const [displaySdkView, setDisplaySdkView] = useState($tlf.flipperEnableSpendingSettingsSdkToggle);

  const handleChange = (event) => {
    setDisplaySdkView(event.target.checked);
  };

  return (
    <div>
      {$tlf.flipperEnableSpendingSettingsSdkToggle && (
        <div style={{ marginTop: 50 }}>
          <TrueLinkBanner
            dismissible
            text={
              'Our improved navigation makes updating settings easier. The settings on your True Link Cards have not changed, we’re just displaying them to you in a new format. For a limited time, you can return to the classic experience in the toggle below.'
            }
            title={'Our Spending Settings have been updated!'}
            variant="promo"
          />
          <Grid
            alignItems="center"
            container
            direction="row"
            justifyContent="flex-end"
            sx={{ p: 2 }}
          >
            <div>Viewing Updated Experience</div>
            <Switch checked={displaySdkView} onChange={handleChange} />
          </Grid>
        </div>
      )}
      {/* Disabling since this was done before we agreed on JSON and APIs */}
      {/* eslint-disable-next-line react/no-danger */}
      {!displaySdkView && <div dangerouslySetInnerHTML={{ __html: cardSettings }} />}
      {displaySdkView && (
        <SpendingSettingsSdkContainer accountId={`${accountId}`} canEdit={false} />
      )}
    </div>
  );
}

SpendingSettingsSdkContainerWrapper.propTypes = {
  accountId: PropTypes.string,
  cardSettings: PropTypes.node,
};
